module.exports = __webpack_public_path__ + "img/T1A_rc_15.a126ef98.png";